module.exports = __webpack_public_path__ + "img/icon_ts_gx@3x.f4e4ed04.png";